import echarts from 'echarts';
import chinaMapData from './china';

const SELECT_TYPE_SINGLE = 'single';
const SELECT_TYPE_MULTIPLE = 'multiple';

const COLORS = {
  1: ['#343239', '#0f3341', '#085d63', '#178d77', '#4dbe78', '#9be66d'],
  2: ['#343239', '#58325b', '#5c365c', '#87446b', '#c85575', '#f66c77']
};
const borderColors = {
  1: '#3A6561',
  2: '#7F4856'
};
const NAME_MAP = {
  北京: '北京市',
  天津: '天津市',
  重庆: '重庆市',
  上海: '上海市',
  内蒙古: '内蒙古自治区',
  宁夏: '宁夏回族自治区',
  广西: '广西壮族自治区',
  新疆: '新疆维吾尔自治区',
  澳门: '澳门特别行政区',
  西藏: '西藏自治区',
  香港: '香港特别行政区',
  台湾: '台湾省'
};

const NAME_MAP_REVERSE = {};
Object.keys(NAME_MAP).forEach((k) => {
  NAME_MAP_REVERSE[NAME_MAP[k]] = k;
});

const convertProvinceName = (name) => {
  return name in NAME_MAP ? NAME_MAP[name] : `${name}省`;
};

class ChinaProvinceMap {
  constructor({ elem, selectType = 'single', onselectchange = () => {} }) {
    this.elem = elem;
    this.map = echarts.init(elem);
    this.chinaData = chinaMapData.map((item) => {
      item.value = 0;
      return item;
    });
    this.selectType = selectType;
    this.onselectchange = onselectchange;
    this.provinceSelected = [];
    this.colorMin = 0;
    this.colorMax = 0;
    // 监听事件
    this.map.on('mapselectchanged', (data) => {
      if (data.batch) {
        const name = data.batch[0].name;
        const idx = this.provinceSelected.indexOf(name);
        if (idx >= 0) {
          if (this.selectType === SELECT_TYPE_MULTIPLE) {
            this.provinceSelected.splice(idx, 1);
          }
        } else {
          if (this.selectType === SELECT_TYPE_SINGLE) {
            this.provinceSelected.length = [];
          }
          this.provinceSelected.push(name);
        }
      }
      this.onselectchange(this.provinceSelected.map(convertProvinceName));
    });
    // resize event
    this.resize = () => {
      this.map.resize();
    };
    window.addEventListener('resize', this.resize);
  }

  draw(option = {}) {
    this.map.setOption({
      tooltip: {
        show: true,
        formatter: params => params.data.name,
        triggerOn: 'mousemove'
      },
      series: [
        {
          name: 'ChinaProvinceMap',
          type: 'map',
          mapType: 'china',
          // roam: true,
          zoom: 1.25,
          selectedMode: this.selectType === SELECT_TYPE_MULTIPLE ? 'multiple' : 'single',
          itemStyle: {
            borderWidth: 0.3,
            borderColor: option.borderColor in borderColors ? borderColors[option.borderColor] : borderColors[1],
            areaColor: '#413f45'
          },
          emphasis: {
            itemStyle: {
              borderWidth: 0.5,
              borderColor: 'white',
              areaColor: '#ffffff'
            },
            label: {
              show: false
            }
          },
          data: this.chinaData
        }
      ],
      visualMap: {
        min: this.colorMin,
        max: this.colorMax,
        show: false,
        inRange: {
          color: option.color in COLORS ? COLORS[option.color] : COLORS[1]
        }
      }
    });
  }

  setProvinceValues(values) {
    values = values || {};
    const names = Object.keys(values);
    if (names) {
      this.colorMax = values[names[0]];
      this.colorMin = values[names[0]];
      names.forEach(name => {
        const v = values[name];
        if (v > this.colorMax) {
          this.colorMax = v;
        }
        if (v < this.colorMin) {
          this.colorMin = v;
        }
      });
    } else {
      this.colorMax = 0;
      this.colorMin = 0;
    }
    this.chinaData = this.chinaData.map((item) => {
      item.value = values[NAME_MAP[item.name] || `${item.name}省`] || 0;
      return item;
    });
    return this;
  }

  select(provinceName) {
    const that = this;
    if (this.provinceSelected.indexOf(provinceName) >= 0) {
      return;
    }
    provinceName = provinceName in NAME_MAP_REVERSE ? NAME_MAP_REVERSE[provinceName] : provinceName.slice(0, -1);
    for (let i = 0; i < this.chinaData.length; i++) {
      if (this.chinaData[i].name === provinceName) {
        if (this.selectType === SELECT_TYPE_SINGLE) {
          this.provinceSelected.forEach((item) => {
            that.map.dispatchAction({
              type: 'mapUnSelect',
              name: item
            });
          });
          this.provinceSelected.length = 0;
        }
        this.map.dispatchAction({
          type: 'mapSelect',
          dataIndex: i
        });
        this.provinceSelected.push(provinceName);
      }
    }
  }

  unselect(provinceName) {
    const idx = this.provinceSelected.indexOf(provinceName);
    if (idx < 0) {
      return;
    }
    this.map.dispatchAction({
      type: 'mapUnselect',
      name: provinceName
    });
    this.provinceSelected.splice(idx, 1);
  }

  getProvinceSelected() {
    return this.provinceSelected;
  }

  destroy() {
    this.map.dispose();
    delete this.elem;
    delete this.provinceSelected;
    delete this.chinaData;
    window.removeEventListener('resize', this.resize);
  }
}

export default ChinaProvinceMap;
